import React, { useCallback } from 'react';

import MuiPagination from '@material-ui/lab/Pagination';

interface PaginationProps {
  page: number;
  count: number;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  onChange: (i: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  page,
  count,
  className,
  size = 'small',
  onChange,
}) => {
  const handleChange = useCallback((_: any, newPage: any) => onChange?.(newPage), [onChange]);

  return (
    <MuiPagination
      size={size}
      page={page}
      count={count}
      shape="rounded"
      className={className}
      onChange={handleChange}
    />
  );
};

export default Pagination;
